import { doc, getDoc } from "firebase/firestore";
import { db } from "../config";

export async function checkAppVersion() {
    try {
        const versionRef = doc(db, "versions", "version");
        const versionSnap = await getDoc(versionRef);

        if (versionSnap.exists()) {
            const data = versionSnap.data();
            const versionArray = data.version || [];
            const newsArray = data.news || [];

            const latestVersion = versionArray[versionArray.length - 1];
            const latestNews = newsArray[newsArray.length - 1];

            const localVersion = localStorage.getItem("appVersion");

            if (!localVersion) {
                localStorage.setItem("appVersion", latestVersion);
                return {
                    isUpdated: true,
                    news: latestNews,
                    latestVersion,
                };
            }

            const isUpdated = localVersion === latestVersion;

            if (!isUpdated) {
                localStorage.setItem("appVersion", latestVersion);
            }

            return {
                isUpdated,
                news: latestNews,
                latestVersion,
            };
        } else {
            throw new Error("Құжат табылмады");
        }
    } catch (error) {
        console.error("Нұсқаны тексеру кезінде қате:", error);
        return {
            isUpdated: true,
            news: "",
            latestVersion: "",
        };
    }
}